module.exports = __webpack_public_path__ + "img/swiper_3.5_2_1.4cdbb6c6.webp";